import React, { useLayoutEffect, useRef } from "react";

import { Modal } from "./Modal";
import { ModalService } from "./modal.service";

export const ModalHost = () => {
  const modalRef = useRef();

  // useEffect was replaced due to undefined modalRef reference when user loads the page for a first time
  useLayoutEffect(() => {
    if (modalRef) {
      ModalService.setElement(modalRef);
    }
  });

  return <Modal ref={modalRef} />;
};
